module.exports = __webpack_public_path__ + "img/bim (12).7f016678.png";